<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GTS2kh/tc-custom/9783968657424.jpg?1703042295214" alt="This image is the cover for the book Amazing Stories Volume 21, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 21, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Amazing Stories Volume 21 is a great collection of action short stories from "The Golden Age of Science Fiction". Featured here are eight stories by Bryce Walton: "Martian Nightmare", "The Last Laugh", "In His Image", "The Ultimate World", "Mary Anonymous", "Prisoner of the Brain-Mistress", "Savage Galahad", and "Last Call".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryce Walton
      </h2>
      
      <p class="authorDescription body article">Bryce Walton (May 31, 1918 – February 5, 1988) was an American pulp fiction writer. During World War II, he served as a navy correspondent. In 1945, he began a career as a freelance writer. He attended California State College from 1946 to 1947, then married photographer Ruth Arschinov on January 1, 1954. The couple had one daughter, Krissta Kay. He was credited as a writer for the TV serial Captain Video and His Video Rangers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec777a34